import {
	ADD_ROLE_TO_USERS_FAIL,
	ADD_ROLE_TO_USERS_START, ADD_ROLE_TO_USERS_SUCCESS,
	AUTH_FAIL,
	AUTH_START,
	AUTH_SUCCESS,
	CHANGE_PASSWORD_FAIL,
	CHANGE_PASSWORD_START,
	CHANGE_PASSWORD_SUCCESS,
	FORGOT_PASSWORD_FAIL,
	FORGOT_PASSWORD_START,
	FORGOT_PASSWORD_SUCCESS, GET_ALL_COMPANIES_FAIL,
	GET_ALL_COMPANIES_START, GET_ALL_COMPANIES_SUCCESS, GET_ALL_USERS_FAIL, GET_ALL_USERS_START, GET_ALL_USERS_SUCCESS,
	GET_USERS_COMPANY_FAIL, GET_USERS_COMPANY_START, GET_USERS_COMPANY_SUCCESS,
	REGIST_FAIL,
	REGIST_START,
	REGIST_SUCCESS,
	SEND_NEW_PASSWORD_FAIL,
	SEND_NEW_PASSWORD_START,
	SEND_NEW_PASSWORD_SUCCESS, UPDATE_USER_FAIL, UPDATE_USER_START, UPDATE_USER_SUCCESS
} from "./actions/ActionTypes";


export const initAuthState = () => {
	return {
		username: {},
		token: "",
		
		loadingLogin: true,
		errorLogin: "",
		
		loadingRegister: true,
		errorRegister: "",
		
		loadingChangePassword: true,
		errorChangePassword: "",
		
		loadingSendNewPassword: true,
		errorSendNewPassword: "",
		
		users: [],
		loadingGetAllUsers: true,
		errorGetAllUsers: "",
		
		companies: [],
		loadingGetCompanies: true,
		errorGetCompanies: "",
		
		loadingUpdateUser: true,
		errorUpdateUser: "",
		
		loadingAddRole: true,
		errorAddRole: "",
	}
}

export const AUTH_INITIAL_STATE = {}

export const AuthReducer = (state = AUTH_INITIAL_STATE, action) => {
	switch (action.type) {
		case AUTH_START:
			return {
				...state,
				loadingLogin: true,
				errorLogin: "",
			}
		case AUTH_SUCCESS:
			return {
				...state,
				username: action.payload.username,
				token: action.payload.token,
				loadingLogin: false,
				errorLogin: "",
			}
		case AUTH_FAIL:
			return {
				...state,
				username: {},
				loadingLogin: false,
				errorLogin: action.error,
			}
		case REGIST_START:
			return {
				...state,
				loadingRegister: true,
				errorRegister: "",
				loadingLogin: true,
				errorLogin: "",
			}
		case REGIST_SUCCESS:
			return {
				...state,
				loadingRegister: false,
				errorRegister: "",
				loadingLogin: true,
				errorLogin: "",
			}
		case REGIST_FAIL:
			return {
				...state,
				loadingRegister: false,
				errorRegister: action.error,
			}
		case CHANGE_PASSWORD_START:
			return {
				...state,
				loadingChangePassword: true,
				errorChangePassword: "",
			}
		case CHANGE_PASSWORD_SUCCESS:
			return {
				...state,
				loadingChangePassword: false,
				errorChangePassword: "",
			}
		case CHANGE_PASSWORD_FAIL:
			return {
				...state,
				loadingChangePassword: false,
				errorChangePassword: action.error,
			}
		case SEND_NEW_PASSWORD_START:
			return {
				...state,
				loadingSendNewPassword: true,
				errorSendNewPassword: "",
			}
		case SEND_NEW_PASSWORD_SUCCESS:
			return {
				...state,
				loadingSendNewPassword: false,
				errorSendNewPassword: "",
			}
		case SEND_NEW_PASSWORD_FAIL:
			return {
				...state,
				loadingSendNewPassword: false,
				errorSendNewPassword: "Boia faus... ie chei cos che va nen...la rangiuma subit!",
			}
		case GET_USERS_COMPANY_START:
			return {
				...state,
				users: [],
				loadingGetAllUsers: true,
				errorGetAllUsers: "",
			}
		case GET_USERS_COMPANY_SUCCESS:
			return {
				...state,
				users: action.payload,
				loadingGetAllUsers: false,
				errorGetAllUsers: "",
			}
		case GET_USERS_COMPANY_FAIL:
			return {
				...state,
				users: [],
				loadingGetAllUsers: false,
				errorGetAllUsers: action.error,
			}
		case GET_ALL_USERS_START:
			return {
				...state,
				users: [],
				loadingGetAllUsers: true,
				errorGetAllUsers: "",
			}
		case GET_ALL_USERS_SUCCESS:
			return {
				...state,
				users: action.payload,
				loadingGetAllUsers: false,
				errorGetAllUsers: "",
			}
		case GET_ALL_USERS_FAIL:
			return {
				...state,
				users: [],
				loadingGetAllUsers: false,
				errorGetAllUsers: action.error,
			}
		case FORGOT_PASSWORD_START:
			return {
				...state,
				loadingSendNewPassword: true,
				errorSendNewPassword: "",
			}
		case FORGOT_PASSWORD_SUCCESS:
			return {
				...state,
				loadingSendNewPassword: false,
				errorSendNewPassword: "",
			}
		case FORGOT_PASSWORD_FAIL:
			return {
				...state,
				loadingSendNewPassword: false,
				errorSendNewPassword: action.error,
			}
		case GET_ALL_COMPANIES_START:
			return {
				...state,
				companies: [],
				loadingGetCompanies: true,
				errorGetCompanies: "",
			}
		case GET_ALL_COMPANIES_SUCCESS:
			return {
				...state,
				companies: action.payload,
				loadingGetCompanies: false,
				errorGetCompanies: "",
			}
		case GET_ALL_COMPANIES_FAIL:
			return {
				...state,
				companies: [],
				loadingGetCompanies: false,
				errorGetCompanies: action.error,
			}
		case UPDATE_USER_START:
			return {
				...state,
				loadingUpdateUser: true,
				errorUpdateUser: "",
			}
		case UPDATE_USER_SUCCESS:
			return {
				...state,
				loadingUpdateUser: false,
				errorUpdateUser: "",
			}
		case UPDATE_USER_FAIL:
			return {
				...state,
				loadingUpdateUser: false,
				errorUpdateUser: action.error,
			}
		case ADD_ROLE_TO_USERS_START:
			return {
				...state,
				loadingAddRole: true,
				errorAddRole: "",
			}
		case ADD_ROLE_TO_USERS_SUCCESS:
			return {
				...state,
				loadingAddRole: false,
				errorAddRole: "",
			}
		case ADD_ROLE_TO_USERS_FAIL:
			return {
				...state,
				loadingAddRole: false,
				errorAddRole: action.error,
			}
		
		default:
			return state;
	}
}
